// 
// -----------------------------------------------------------------------------
(function ($price) {
	if ($price.length === 0) {return false;}

$('input:radio').click(function() {
  $('input:radio[name='+$(this).attr('name')+']').closest('.price').removeClass('active');
        $(this).closest('.price').addClass('active');
});

})($( '.price' ));